import { tempToColor, timestampConverter } from "../utils/helpers";

function WeatherInfoDisplay({
  timestamp,
  pressure,
  temp,
  visibility,
  humidity,
  clouds,
  tempColor,
}) {
  return (
    <div
      style={{
        transition: ".5s",
        backgroundColor: `${tempToColor(tempColor)}`,
        width: "100%",
        padding: "20px",
        borderRadius: "20px",
      }}
    >
      <h3 style={{ textAlign: "center" }}>Weather Information</h3>
      <p>
        <strong>Date: </strong>
        {timestampConverter(timestamp)}
      </p>
      <p>
        <strong>wind pressure: </strong> {pressure} hPa
      </p>
      <p>
        <strong>temperature: </strong> {temp} celcius
      </p>
      <p>
        <strong>visibility: </strong> {visibility} meters
      </p>
      <p>
        <strong>humidity: </strong> {humidity} %
      </p>
      <p>
        <strong>cloud cover: </strong> {clouds} %
      </p>
    </div>
  );
}

export default WeatherInfoDisplay;
